"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var Checkbox_1 = __importDefault(require("../../Checkbox"));
var DataContext_1 = require("../DataContext");
function Row(_a) {
    var id = _a.id, children = _a.children, grayed = _a.grayed, onClick = _a.onClick, otherClick = _a.otherClick;
    var _b = React.useState(false), isTouching = _b[0], setTouching = _b[1];
    var _c = (0, DataContext_1.useDataContext)(), bulkAction = _c.bulkAction, editMode = _c.editMode, skeleton = _c.skeleton, onEditMode = _c.onEditMode, selectedRowsId = _c.selectedRowsId, onSelectRow = _c.onSelectRow;
    var active = selectedRowsId === null || selectedRowsId === void 0 ? void 0 : selectedRowsId.includes(id);
    var classNameRow = (0, classnames_1.default)("nimbus--data-list-row", {
        "nimbus--data-list-row--grayed": grayed,
        "nimbus--data-list-row--touching": isTouching,
    });
    var classNameRowCheck = (0, classnames_1.default)("nimbus--data-list-row__item nimbus--data-list-row__check-wrapper", {
        "is--visible": editMode,
    });
    var time = React.useRef();
    var handleOnSelectRow = function (rowId) {
        if (!(bulkAction === null || bulkAction === void 0 ? void 0 : bulkAction.disabled))
            onSelectRow === null || onSelectRow === void 0 ? void 0 : onSelectRow(rowId);
    };
    var handleTouchStart = function () {
        if (onSelectRow) {
            setTouching(true);
            time.current = window.setTimeout(function () {
                setTouching(false);
                if (!editMode) {
                    onEditMode === null || onEditMode === void 0 ? void 0 : onEditMode();
                }
                handleOnSelectRow(id);
            }, 500);
        }
    };
    var handleCancelTouch = function () {
        clearTimeout(time.current);
        setTouching(false);
    };
    var handleClick = function (event) {
        event.stopPropagation();
        if (editMode) {
            handleOnSelectRow(id);
        }
        else {
            if (otherClick) {
                otherClick(event);
                return
            }
            onClick === null || onClick === void 0 ? void 0 : onClick(id);
        }
    };
    var handleChange = function () {
        handleOnSelectRow(id);
    };
    return (React.createElement("div", { onTouchStart: handleTouchStart, onTouchEnd: handleCancelTouch, onTouchMove: handleCancelTouch, onTouchCancel: handleCancelTouch, onClick: handleClick, className: classNameRow },
        onSelectRow && editMode && (React.createElement("div", { className: classNameRowCheck }, skeleton ? (React.createElement(Checkbox_1.default, { name: id, disabled: true })) : (React.createElement(Checkbox_1.default, { name: id, checked: active, disabled: bulkAction === null || bulkAction === void 0 ? void 0 : bulkAction.disabled, onChange: handleChange })))),
        children));
}
exports.default = Row;
//# sourceMappingURL=Row.js.map